var Component = require("!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./HotProducts.vue"),
  /* template */
  require("!!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-8fdbf9ce!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./HotProducts.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/HotProducts.vue
// module id = 942
// module chunks = 40